import RMSDashboardOnboardedContainer from "./RMSDashboardOnboardedContainer";
import RMSDashboardOnboardedStore from "./RMSDashboardOnboardedStore";
export default RMSDashboardOnboardedStore(RMSDashboardOnboardedContainer)